import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useSnackbar } from 'notistack'
import { defaultBannerBarData } from './defaultBannerBarData'
import AddBannerBarForm from './AddBannerBarForm'
import { addBanner } from 'app/redux/store/features/banners'
import dateFormat from 'dateformat'

function toStartOfDay(value) {
    if (value == null) return value
    const d = value instanceof Date ? new Date(value.getTime()) : new Date(value)
    if (isNaN(d.getTime())) return value
    d.setHours(0, 0, 0, 0)
    return d
}

const AddBannerBar = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { enqueueSnackbar } = useSnackbar()
    const todayStart = (() => {
        const d = new Date()
        d.setHours(0, 0, 0, 0)
        return d
    })()
    const todayEnd = (() => {
        const d = new Date()
        d.setDate(d.getDate() + 2000)
        d.setHours(0, 0, 0, 0)
        return d
    })()

    const [BannerBarData] = useState({
        ...defaultBannerBarData,
        dateStart: todayStart,
        dateEnd: todayEnd,
    })
    const [apiCallInProgress, setApiCallInProgress] = useState(false)
    const { loading, error } = useSelector((state) => state.banners)

    useEffect(() => {
        if (!apiCallInProgress || loading) return
        setApiCallInProgress(false)
        if (error) handleError(error)
        else {
            enqueueSnackbar('Banner Bar added successfully', {
                variant: 'success',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
            navigate('/settings/configuration/banner-bar')
        }
    }, [loading])

    function handleError(error) {
        if (error.status === '401') {
            navigate('/profile/signout')
        } else if (error.detail) {
            enqueueSnackbar(error.detail, {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
        } else {
            enqueueSnackbar(error, {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
        }
    }

    const onAddBannerBar = useCallback((e) => {
        console.log(e)
        setApiCallInProgress(true)

        const form = new FormData()
        form.append('dateStart', dateFormat(toStartOfDay(BannerBarData.dateStart) ?? BannerBarData.dateStart, 'isoDateTime', true))
        form.append('dateEnd', dateFormat(BannerBarData.dateEnd, 'isoDateTime', true))
        form.append('orderBy', BannerBarData.orderBy)
        form.append('image', BannerBarData.file[0])
        form.append('navigationLink', BannerBarData.navigationLink)
        form.append('subText', BannerBarData.subText)
        e.preventDefault()
        dispatch(
            addBanner(form, {
                'Content-Type': 'multipart/form-data',
            })
        )
    }, [])

    return (
        <React.Fragment>
            <AddBannerBarForm BannerBarData={BannerBarData} addBannerBar={onAddBannerBar} />
        </React.Fragment>
    )
}

export default AddBannerBar
